export default async string => {
  try {
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(string)
      return
    }
    // Fallback for older browsers
    const el = document.createElement('textarea')
    el.value = string
    el.setAttribute('readonly', '')
    el.style.position = 'absolute'
    el.style.left = '-999px'
    document.body.appendChild(el)
    const selected =
      document.getSelection().rangeCount > 0
        ? document.getSelection().getRangeAt(0)
        : false
    el.select()
    document.body.removeChild(el)
    if (selected) {
      document.getSelection().removeAllRanges()
      document.getSelection().addRange(selected)
    }
    return
  } catch (e) {
    console.warn(e)
    return
  }
}
